module.exports = __webpack_public_path__ + "static/media/paypass.546fd388.svg";